/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Nav_ItemInputs */

const en_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const id_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun`)
};

const ms_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun`)
};

const ca_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte`)
};

const cs_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const da_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const de_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const et_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const es_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const fr_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte`)
};

const hr_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Račun`)
};

const it_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const lv_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konts`)
};

const lt_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paskyra`)
};

const hu_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiók`)
};

const nl_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const nb_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const pl_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const pt_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const ro_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cont`)
};

const sk_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet`)
};

const sl_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Račun`)
};

const fi_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tili`)
};

const sv_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const vi_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản`)
};

const tr_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap`)
};

const el_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λογαριασμός`)
};

const bg_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профил`)
};

const ru_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const sr_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`налог`)
};

const uk_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обліковий запис`)
};

const ka_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ანგარიში`)
};

const hi_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खाता`)
};

const th_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const ko_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정`)
};

const zh_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账户`)
};

const zh_tw_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帳戶`)
};

const ja_account_nav_item = /** @type {(inputs: Account_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Account_Nav_ItemInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const account_nav_item = /** @type {((inputs?: Account_Nav_ItemInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Nav_ItemInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_account_nav_item(inputs)
	if (locale === "ms") return ms_account_nav_item(inputs)
	if (locale === "ca") return ca_account_nav_item(inputs)
	if (locale === "cs") return cs_account_nav_item(inputs)
	if (locale === "da") return da_account_nav_item(inputs)
	if (locale === "de") return de_account_nav_item(inputs)
	if (locale === "et") return et_account_nav_item(inputs)
	if (locale === "es") return es_account_nav_item(inputs)
	if (locale === "fr") return fr_account_nav_item(inputs)
	if (locale === "hr") return hr_account_nav_item(inputs)
	if (locale === "it") return it_account_nav_item(inputs)
	if (locale === "lv") return lv_account_nav_item(inputs)
	if (locale === "lt") return lt_account_nav_item(inputs)
	if (locale === "hu") return hu_account_nav_item(inputs)
	if (locale === "nl") return nl_account_nav_item(inputs)
	if (locale === "nb") return nb_account_nav_item(inputs)
	if (locale === "pl") return pl_account_nav_item(inputs)
	if (locale === "pt") return pt_account_nav_item(inputs)
	if (locale === "ro") return ro_account_nav_item(inputs)
	if (locale === "sk") return sk_account_nav_item(inputs)
	if (locale === "sl") return sl_account_nav_item(inputs)
	if (locale === "fi") return fi_account_nav_item(inputs)
	if (locale === "sv") return sv_account_nav_item(inputs)
	if (locale === "vi") return vi_account_nav_item(inputs)
	if (locale === "tr") return tr_account_nav_item(inputs)
	if (locale === "el") return el_account_nav_item(inputs)
	if (locale === "bg") return bg_account_nav_item(inputs)
	if (locale === "ru") return ru_account_nav_item(inputs)
	if (locale === "sr") return sr_account_nav_item(inputs)
	if (locale === "uk") return uk_account_nav_item(inputs)
	if (locale === "ka") return ka_account_nav_item(inputs)
	if (locale === "hi") return hi_account_nav_item(inputs)
	if (locale === "th") return th_account_nav_item(inputs)
	if (locale === "ko") return ko_account_nav_item(inputs)
	if (locale === "zh") return zh_account_nav_item(inputs)
	if (locale === "zh-tw") return zh_tw_account_nav_item(inputs)
	if (locale === "ja") return ja_account_nav_item(inputs)
	return en_account_nav_item(inputs)
});